var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_5439)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_427_5439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8001 136C18.2662 136 0 117.734 0 95.2002V40.8001C0 18.2662 18.2662 0 40.8001 0H95.2002C117.734 0 136 18.2662 136 40.8001V95.2002C136 117.734 117.734 136 95.2002 136H40.8001Z",
    fill: "#F36527"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_427_5439)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_427_5439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.011 82.23L95.0356 85.3466L35.2574 74.3321L29.8506 68.9329C29.243 68.3272 28.2591 68.3272 27.6543 68.9357C27.0477 69.5414 27.0486 70.5253 27.6562 71.1329L34.0697 77.5369C38.9874 85.5078 49.4768 92.1743 62.4346 94.563C75.3933 96.9498 87.5699 94.4588 95.0052 88.7638L103.28 85.067C104.063 84.7172 104.415 83.7978 104.063 83.0148C103.713 82.2309 102.794 81.8792 102.011 82.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1735 79.0498C83.4655 77.7569 88.1813 70.7794 88.1813 69.0362C88.1813 67.2911 86.9538 65.2238 88.2458 63.9308C89.2126 62.964 88.7216 62.5156 89.1349 61.6293C88.878 61.4796 88.6107 61.2691 88.3386 60.9971C88.0666 60.7251 87.8552 60.4568 87.7055 60.2009C86.8201 60.6141 86.3708 60.1212 85.4021 61.0881C84.112 62.3801 82.0437 61.1526 80.2995 61.1526C78.5535 61.1526 71.5779 65.8702 70.286 67.1622C68.9921 68.4533 69.3419 69.1405 74.7686 74.5662C80.1962 79.9948 80.8797 80.3418 82.1735 79.0498ZM83.929 70.5092C84.2674 70.8097 84.2997 71.3311 83.9954 71.6704L80.1393 75.9995C79.8379 76.3397 79.3175 76.3701 78.9782 76.0668C78.9649 76.0554 78.9545 76.045 78.9431 76.0336C78.636 75.7284 78.6189 75.2326 78.9099 74.9065L82.7679 70.5775C83.0693 70.2372 83.5897 70.2078 83.929 70.5092ZM81.3773 67.9566C81.6996 68.2779 81.6996 68.7992 81.3773 69.1196L77.2843 73.2136C76.9639 73.5359 76.4435 73.5359 76.1212 73.2136C75.8008 72.8922 75.8008 72.3719 76.1212 72.0505L80.2142 67.9556C80.5375 67.6352 81.0569 67.6352 81.3773 67.9566ZM73.3003 70.3926C73.2889 70.3813 73.2785 70.3699 73.269 70.3576C72.9657 70.0192 72.9951 69.4988 73.3354 69.1964L77.6634 65.3385C78.0037 65.0361 78.5203 65.0645 78.8265 65.4048C79.1279 65.7432 79.0967 66.2636 78.7583 66.566L74.4302 70.4249C74.1022 70.7168 73.6055 70.6979 73.3003 70.3926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.339 40.9955C107.727 40.3813 106.729 40.3813 106.115 40.9955L88.0088 59.1003C87.3945 59.7155 89.6192 61.9412 90.2344 61.326L108.339 43.2202C108.953 42.606 108.953 41.6107 108.339 40.9955ZM107.674 42.8231L106.163 44.3331C105.842 44.6535 105.32 44.6535 105 44.3331C104.679 44.0117 104.679 43.4913 105 43.17L106.511 41.66C106.831 41.3387 107.352 41.3387 107.674 41.66C107.994 41.9823 107.994 42.5027 107.674 42.8231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0146 72.8183C62.2232 73.0278 64.5589 71.2429 65.503 68.4637C66.449 65.6835 65.685 62.8455 63.8062 61.6644C64.5721 63.4218 64.6698 65.6864 63.9086 67.9215C63.1493 70.1557 61.6934 71.8922 60.0146 72.8183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2323 72.4297C49.0125 73.3738 51.8495 72.6098 53.0315 70.732C51.2732 71.4988 49.0096 71.5946 46.7745 70.8353C44.5393 70.0751 42.8037 68.6182 41.8757 66.9395C41.6682 69.1499 43.4521 71.4846 46.2323 72.4297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4665 67.2485C55.5063 65.0503 55.3869 62.2189 56.3367 59.4226C57.2865 56.6282 59.1083 54.4566 61.2089 53.2973C58.4448 53.0367 55.5253 55.269 54.3432 58.7458C53.1603 62.2227 54.1157 65.7726 56.4665 67.2485Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_5439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_427_5439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_427_5439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.6,
    height: 54.9303,
    fill: "white",
    transform: "translate(27.2 40.5349)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_427_5439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.6,
    height: 54.9303,
    fill: "white",
    transform: "translate(27.2 40.5349)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.ee0d5eedd77716b5149c4151b00faabf.svg";
export { ForwardRef as ReactComponent };